import { defineStore } from "pinia";
import { i18n } from "@/i18n";
import { usePermissionsStore } from "./permissions";
import axios from "../../axios/requestAxios";
import { sizes } from "../../utils/media-query";

function getTranslation(key) {
	return i18n.global.messages.value.ru.Nav[key];
}

export const useSideMenuStore = defineStore("sideMenu", {
	state: () => {
		return {
			isLargeScreen: sizes()["screen-large"],
			rerenderKey: 0,
			countUnReaded: "",
			trigger: false,
			nav: [
				{
					text: getTranslation("Clients"),
					path: "/clients",
					permissionKey: "Клиенты",
					icon: "user",
				},
				{
					text: getTranslation("Transaction"),
					icon: "folder",
					items: [],
				},
				{
					text: getTranslation("Promotion"),
					path: "/promotions",
					icon: "percent",
					permissionKey: "Акция",
				},
				{
					text: getTranslation("News"),
					icon: "info",
					path: "/all-tabs",
					permissionKey: "Новости",
				},
				{
					text: getTranslation("Notifications"),
					icon: "message",
					path: "/messages",
					permissionKey: "Рассылки для менеджера",
				},
				{
					text: getTranslation("Settings"),
					icon: "folder",
					items: [],
				},
				{
					text: getTranslation("AccessControl"),
					icon: "folder",
					items: [],
				},
				{
					text: getTranslation("Catalogues"),
					icon: "folder",
					items: [],
				},
				{
					text: getTranslation("Logs"),
					path: "/logs",
					icon: "clock",
					permissionKey: "Изменения",
				},
				// {
				// 	text: getTranslation("Branding"),
				// 	icon: "folder",
				// 	items: [],
				// },
				// {
				// 	text: getTranslation("RentAuto"),
				// 	icon: "folder",
				// 	items: [],
				// },
				// {
				// 	text: getTranslation("Dasboard"),
				// 	icon: "folder",
				// 	items: [],
				// },
				// {
				// 	text: getTranslation("Account"),
				// 	icon: "folder",
				// 	items: [],
				// },
			],
			items: [
				{
					text: getTranslation("Users"),
					path: "/employees",
					permissionKey: "Сотрудники",
					accessControl: true,
				},
				{
					text: getTranslation("Comission"),
					path: "/comissions",
					permissionKey: "Комиссия",
					isCatalogue: true,
				},
				{
					text: getTranslation("Comission"),
					path: "/actions",
					permissionKey: "Акция - Купон",
					isCatalogue: true,
				},
				{
					text: getTranslation("BalanceTransaction"),
					path: "/transactions",
					permissionKey: "Транзакции",
					isTransaction: true,
				},
				{
					text: getTranslation("BonusTransactions"),
					path: "/bonus-transactions",
					isTransaction: true,
					permissionKey: "Акция",
				},
				{
					text: getTranslation("Roles"),
					path: "/roles",
					permissionKey: "Роли",
					accessControl: true,
				},
				{
					text: getTranslation("Brand"),
					path: "/brands",
					permissionKey: "Марка авто",
					isCatalogue: true,
				},
				{
					text: getTranslation("Colores"),
					path: "/car-colores",
					permissionKey: "Цвет авто",
					isCatalogue: true,
				},
				{
					text: getTranslation("RejectionReasons"),
					path: "/rejection-reasons",
					permissionKey: "Причины отклонения",
					isCatalogue: true,
				},
				{
					text: getTranslation("Countries"),
					path: "/country",
					permissionKey: "Страны",
					isCatalogue: true,
				},
				{
					text: getTranslation("Category"),
					path: "/categories",
					permissionKey: "Категории",
					isCatalogue: true,
				},
				{
					text: getTranslation("MotivationPhrase"),
					path: "/motivation-phrase",
					permissionKey: "Мотивационная фраза",
					isCatalogue: true,
				},
				{
					text: getTranslation("AppSettings"),
					path: "/settings",
					settings: true,
					permissionKey: "Настройки",
				},
				{
					text: getTranslation("TaxiDepot"),
					path: "/taxi-depots",
					permissionKey: "Таксопарк",
					settings: true,
				},
				{
					text: getTranslation("Amenity"),
					path: "/amenities",
					permissionKey: "Удобства",
					isCatalogue: true,
				},
			],
		};
	},
	actions: {
		rerender() {
			this.rerenderKey += 1;
		},
		updateItemProperties() {
			this.nav = this.nav.map((item) => {
				// переопределяем массив объектов
				if (item.path && !/^\//.test(item.path)) {
					item.path = `/${item.path}`;
				}

				return { ...item, expanded: this.isLargeScreen };
			});
		},
		setItems() {
			let catalog = [];
			let branding = [];
			let settings = [];
			let transactions = [];
			let navMenu = [...this.nav];
			let accessControl = [];

			const permissionsStore = usePermissionsStore();

			navMenu.forEach((navItem) => {
				if (permissionsStore.check(navItem.permissionKey, "navigate")) {
					navItem.flag = true;
				}
			});

			this.items.forEach((item) => {
				if (!permissionsStore.check(item.permissionKey, "navigate")) return;

				if (item.accessControl && accessControl.indexOf((x) => x.path == item.path) == -1) {
					accessControl.push(item);
					return;
				}

				if (item.settings && settings.indexOf((x) => x.path == item.path) == -1) {
					settings.push(item);
					return;
				}

				if (item.isTransaction && transactions.indexOf((x) => x.path == item.path) == -1) {
					transactions.push(item);

					return;
				}

				if (item.isCatalogue && catalog.indexOf((x) => x.path == item.path) == -1) {
					catalog.push(item);
					return;
				}

				if (!item.isCatalogue && !item.isAutoRent && this.nav.indexOf((x) => x.path == item.path) == -1) {
					this.nav.push(item);
					return;
				}
			});
			// --------------------------------------------------------

			navMenu.forEach((navItem) => {
				if (navItem.text === getTranslation("AccessControl") && accessControl.length !== 0) {
					navItem.items = accessControl.sort((a, b) => a.text.localeCompare(b.text));
					navItem.flag = true;
				}

				if (navItem.text === getTranslation("Settings") && settings.length !== 0) {
					navItem.items = settings.sort((a, b) => a.text.localeCompare(b.text));
					navItem.flag = true;
				}

				if (navItem.text === getTranslation("Catalogues") && catalog.length !== 0) {
					navItem.items = catalog.sort((a, b) => a.text.localeCompare(b.text));
					navItem.flag = true;
				}

				if (navItem.text === getTranslation("Branding") && branding.length !== 0) {
					navItem.items = branding.sort((a, b) => a.text.localeCompare(b.text));
					navItem.flag = true;
				}

				if (navItem.text === getTranslation("Transaction") && transactions.length !== 0) {
					navItem.items = transactions.sort((a, b) => a.text.localeCompare(b.text));
					navItem.flag = true;
				}
			});

			navMenu = navMenu.filter((navItem) => {
				return navItem.flag;
			});
			this.nav = [...navMenu];

			this.rerender();
		},
		reset() {
			this.setItems();
			this.rerenderKey++;
		},
		async getCountNotify() {
			return new Promise((resolve, reject) => {
				axios
					.get("/api/ManagerNotification/Unreaded")
					.then(async (response) => {
						this.countUnReaded = response.data;
						this.setUnReadCount(this.countUnReaded);

						resolve(response);
					})
					.catch((error) => {
						this.countUnReaded = "";
						reject(error.response);
					});
			});
		},
		setUnReadCount(count) {
			const notificationText = getTranslation("Notifications");
			this.nav.forEach((e) => {
				if (e.text.includes(notificationText)) {
					e.text = count ? `${notificationText} ${count}` : notificationText;
					this.trigger = !!count;
					this.rerenderKey++;
				}
			});
		},
	},
});
